import { render, staticRenderFns } from "./TablePopoverActionColumn.vue?vue&type=template&id=1e801272"
import script from "./TablePopoverActionColumn.vue?vue&type=script&lang=js"
export * from "./TablePopoverActionColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports